import { ControllerRenderProps } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import { getLinkedLicences } from "@/sideEffects/api";
import React from "react";
import { useSelector } from "react-redux";
import { selectActiveFirm } from "@/store/appSelectors";
import { useTranslation } from "react-i18next";
import { AppSelect, Option } from "@/components/ui/app-select";
import { KeyIcon } from "lucide-react";

export const PlayerFirmLicenceSelect: React.FC<{
  field: ControllerRenderProps<any>;
  colorScheme?: 'blue' | 'purple' | 'green' | 'amber' | 'default';
}> = ({ field, colorScheme = 'default' }) => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);
  const { data, isLoading } = useQuery({
    queryFn: () =>
      getLinkedLicences(
        {
          numberOfObjectsPerPage: 1000,
          pageNumber: 1,
        },
        {
          FirmGuid: String(activeFirm?.firmGuid),
          Available: 0,
        }
      ),
    queryKey: ["getLinkedLicences"],
  });

  const options: Option[] = React.useMemo(() => {
    if (!data?.data?.result) return [];
    
    return data.data.result.map((licence) => ({
      value: licence.intId,
      label: `${licence.intId} - ${licence.licenceExpiry}`,
      icon: <KeyIcon className="h-4 w-4" />
    }));
  }, [data?.data?.result]);

  return (
    <AppSelect
      value={field.value}
      onChange={(value) => field.onChange(Number(value))}
      options={options}
      isLoading={isLoading}
      placeholder={t("entities.firmLicence")}
      label={t("entities.firmLicence")}
      colorScheme={colorScheme}
    />
  );
};
